import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-select-form-field',
    templateUrl: './select-search-input.component.html',
    standalone: false
})
export class SelectSearchInputComponent {
  @Input({ required: true }) options: any[];
  @Input({ required: true }) control: FormControl;
  @Input({ required: true }) label: string;

  @Input() placeholder: string = 'Selecione um item';
  @Input() display: (value: any) => string = (data: any) => (data ? data.name : '');

  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  filteredOptions: any[] = [];

  filterOptions() {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    this.filteredOptions = this.options.filter((option) => this.display(option).toLowerCase().includes(filterValue));
  }

  clearSelect() {
    this.control.patchValue('');
  }
}
